import { metaKey } from '~/scripts/utils';

export default async ({ route, store }) => {
  const steps = ['your-home', 'about-you', 'declarations'];
  const currentStep = metaKey(route, 'formStep');
  const stepIndex = steps.indexOf(currentStep);
  const formSteps = [];
  steps.forEach((step, i) => {
    const h = {};
    h.active = i === stepIndex;
    h.complete = stepIndex > i;
    h.step = step;
    h.text = store.$i18n.t(`forms.steps.${step}`);
    formSteps.push(h);
  });
  store.commit('pageContent/setFormStep', currentStep);
  store.commit('pageContent/setFormSteps', formSteps);
};
